import Entity from '../entity'
export default class Marca extends Entity<number>{
    nombre: string;
    pais: string;
    clienteId: number;
    imagen: string;
    fileContent: string;

}